import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'translation' })
export class TranslationPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: string): Promise<string> {
    return this.translateService.get(value).toPromise();
  }
}
